import { ShoppingIcon, CartIconContainer, ItemCount } from "./shop-icon.styles.jsx"
import { useDispatch, useSelector } from "react-redux";
import { selectCartCount, selectIsCartOpen } from "../../store/cart/cart.selector.js";
import { setIsOpen } from "../../store/cart/cart.actions.js";

const ShopIcon = () => {
    // const { isCartOpen, setIsCartOpen, cartCount } = useContext(CartContext);
    const dispatch = useDispatch();
    const cartCount = useSelector(selectCartCount);
    const isCartOpen = useSelector(selectIsCartOpen)
    const toggleIsCartOpen = () => dispatch(setIsOpen(!isCartOpen))

    return <CartIconContainer onClick={toggleIsCartOpen}>
        <ShoppingIcon className="shopping-icon"></ShoppingIcon>
        <ItemCount className="item-count">{cartCount}</ItemCount>
    </CartIconContainer>

}
export default ShopIcon